import axios from "axios";

const apiGd = axios.create({
  baseURL: process.env.REACT_APP_API_URL_GD,
});

export default apiGd;
